import { render, staticRenderFns } from "./CommentarySummaryTab.vue?vue&type=template&id=25fc205a&scoped=true"
import script from "./CommentarySummaryTab.vue?vue&type=script&lang=js"
export * from "./CommentarySummaryTab.vue?vue&type=script&lang=js"
import style0 from "./CommentarySummaryTab.vue?vue&type=style&index=0&id=25fc205a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fc205a",
  null
  
)

export default component.exports